import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { Waitlist, WalkinWaitlistRequest, WalkinWaitlistPartyDetail } = protos;

export function addToWaitlist(
  requestData: core.IWaitlist,
  showToastParams = true
): ApiAction<core.Waitlist> {
  const request = Waitlist.fromObject(requestData);

  const toastParams = {
    toast: "Thanks! We've added you to the waitlist.",
  };

  return {
    TockApi: {
      postProto: '/waitlist',
      type: AppConstants.NULL,
      request,
      ...(showToastParams ? toastParams : {}),
    },
  };
}

/**
 * Adds a party to the WalkInWaitlist
 * @param {core.IWalkinWaitlistRequest} walkinWaitlistParty party to add.
 * @returns {Object} A redux TockApi action.
 */
export function addToWalkinWaitlist(requestData: core.IWalkinWaitlistRequest): ApiAction {
  const request = WalkinWaitlistRequest.fromObject(requestData);
  return {
    TockApi: {
      postProto: '/walkin-waitlist',
      type: AppConstants.WALK_IN_WAITLIST_ADD,
      request,
      toast: "Joined waitlist. You'll receive updates via text",
    },
  };
}

/**
 * Removes a party from a WalkInWaitlist
 * @param {core.IWalkinWaitlistPartyDetail | null} walkinWaitlistParty party to remove.
 * @returns {Object} A redux TockApi action.
 */
export function removeFromWalkInWaitlist(
  walkinWaitlistParty: null | core.IWalkinWaitlistPartyDetail
): ApiAction {
  const request = WalkinWaitlistPartyDetail.fromObject(walkinWaitlistParty);

  return {
    TockApi: {
      postProto: `/walkin-waitlist/cancel`,
      request,
      type: AppConstants.WALK_IN_WAITLIST_CANCEL,
      toast: 'Waitlist request canceled',
    },
  };
}

/**
 * Gets the size of a business's walk in waitlist
 * @param businessId
 * @returns {Object} A redux TockApi action.
 */
export function getWalkinWaitlistSize(businessId: number | null | undefined): ApiAction {
  return {
    TockApi: {
      getProto: `/walkin-waitlist/${businessId}`,
      type: AppConstants.NULL,
    },
  };
}

/**
 * Gets the current position of a party on the walk in waitlist or if they've canceled or been seated
 * @param {core.IWalkinWaitlistPartyDetail.partyId} partyId to get waitlist party position for
 * @returns {Object} A redux TockApi action.
 */
export function getWalkinWaitlistPartyStatus(partyId: number): ApiAction {
  return {
    TockApi: {
      getProto: `/walkin-waitlist/status/${partyId}`,
      type: AppConstants.WALK_IN_WAITLIST_PARTY_STATUS,
    },
  };
}

/**
 * Gets service date and business information for a partyId
 * @param {core.IWalkinWaitlistPartyDetail.partyId} partyId to get additional details for
 * @returns {Object} A redux TockApi action.
 */
export function getWalkinWaitlistPartyDetails(partyId: number): ApiAction {
  return {
    TockApi: {
      getProto: `/walkin-waitlist/party/${partyId}`,
      type: AppConstants.WALK_IN_WAITLIST_PARTY_DETAIL,
    },
  };
}

/**
 * Checks cookies for existing walk in waitlist data to restore state
 * @returns {Object} A redux BaseTock action.
 */
export function restoreWalkinWaitlist(): BaseTockAction {
  return {
    type: AppConstants.WALK_IN_WAITLIST_RESTORE,
  };
}
